<template>
  <button v-if="url || history.length > 2" class="back-button" @click="goBack">
    <svg-icon icon="arrow-left" />
    <span>{{ _text | upperCase }}</span>
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },

    url: {
      type: String,
      default: ''
    }
  },

  computed: {
    _text() {
      return this.text !== '' ? this.text : this.$t('back');
    },

    history() {
      return window.history;
    }
  },

  methods: {
    goBack() {
      if (this.url) {
        this.$router.push(this.url);
        return;
      }

      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.back-button {
  font-weight: 700;
  color: $primary;
  text-transform: uppercase;
  background: none;
  border: none;
  padding: 0;
  white-space: nowrap;
  cursor: pointer;

  .icon {
    margin-right: 0.5rem;
    top: -1px;
  }

  span {
    font-size: 80%;
  }

  & > * {
    vertical-align: middle;
  }
}
</style>
